import InvestmentsStatistics from "./InvestmentsStatistics"

export default InvestmentsStatistics
